// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17y0q","clinicsSelect":"styles_clinicsSelect__3FW_8"};